import type React from 'react';
import { useMemo } from 'react';

import { EmployerBrandingFlag } from '@xing-com/crate-entity-pages-common';
import { useEditStore } from '@xing-com/crate-entity-pages-entity-pages-shared-context-edit-context';
import { usePageContext } from '@xing-com/crate-entity-pages-entity-pages-shared-context-entity-page-context';
import { useFeatureSwitch } from '@xing-com/hub';
import { useMediaListener } from '@xing-com/util';

import { getImagesUrl } from '../../utils/cover-media';
import { EditCoverMenu } from '../edit/edit-cover/edit-cover-menu';

import { CoverMedia } from './cover-media';
import { CoverMediaHeader } from './cover-media-header';
import * as Styled from './cover-media.styles';

export const ENTITY_PAGES_UNFENCE_HEADER = 'entity_pages_unfence_header';

type CoverMediaContainerProps = {
  canBeEdited?: boolean;
};
export const CoverMediaContainer: React.FC<CoverMediaContainerProps> = () => {
  const isEditing = useEditStore(({ isEditing }) => isEditing);
  const { pageContext } = usePageContext();

  const breakpoint = useMediaListener();
  const hasFenceFS = useFeatureSwitch(ENTITY_PAGES_UNFENCE_HEADER, false);

  const { isFreePage, isCompanyPage, coverImage } = pageContext;
  const isFreeHeaderProfile = hasFenceFS && isFreePage && isCompanyPage;

  const coverImageSrc = useMemo(() => {
    if (!coverImage) return undefined;
    const covers = getImagesUrl(coverImage);
    return covers?.[breakpoint];
  }, [coverImage, breakpoint]);

  if ((!hasFenceFS && isFreePage) || (isFreeHeaderProfile && !isEditing)) {
    return <CoverMedia />;
  }

  return (
    <>
      <CoverMediaHeader />
      <CoverMedia coverImageSrc={coverImageSrc} />

      {isEditing ? (
        <Styled.EditingWrapperCover>
          {isFreeHeaderProfile ? (
            <EmployerBrandingFlag hasImage={!!coverImageSrc} />
          ) : null}
          <EditCoverMenu />
        </Styled.EditingWrapperCover>
      ) : null}
    </>
  );
};
